import { render, staticRenderFns } from "./PayorTransferModel.vue?vue&type=template&id=b0d22aac&"
import script from "./PayorTransferModel.vue?vue&type=script&lang=js&"
export * from "./PayorTransferModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports